import ChangePassModal from './change-pass-modal/ChangePassModal';
import ComponentHelper from '../../../supers/ComponentHelper';
import RESTService from '../../../services/RESTService';
import AuthService from '../../../services/AuthService';
import Spinner from '../../../components/spinner/Spinner';
import React from 'react';
import InputField from '../../../components/input-field/InputField';

const connect = new RESTService();
const auth = new AuthService();

class UserInfo extends ComponentHelper {
	constructor(props) {
		super(props);
		this.state = {
			fetchStatus: 'init',
			fetchError: null,
			updateStatus: 'init',
			updateError: null,
			firstName: '',
			lastName: '',
			email: auth.decodedToken.email,
			validationErrors: [],
			activeModal: null
		};
	}

	componentDidMount() {
		this.setState({ fetchStatus: 'pending', fetchError: null });
		connect
			.getMyProfile()
			.then(({ data: { firstName, lastName } }) => {
				this.setState({
					fetchStatus: 'success',
					firstName,
					lastName
				});
			})
			.catch(({ message }) => this.setState({ fetchStatus: 'failure', fetchError: message }));
	}

	handleFormChange = e => {
		this.setState({ [e.target.name]: e.target.value });
	};

	handleSubmit = e => {
		e.preventDefault();
		const validationErrors = this.validate();
		if (validationErrors.length) return this.setState({ validationErrors });
		this.setState({ updateStatus: 'pending', updateError: null, validationErrors: [] });
		connect
			.storeUserProfile({
				firstName: this.state.firstName,
				lastName: this.state.lastName,
				email: this.state.email
			})
			.then(() => this.setState({ updateStatus: 'success' }))
			.catch(({ message }) => this.setState({ updateStatus: 'failure', updateError: message }));
	};

	validate = () => {
		const { firstName, lastName, email } = this.state;
		let errors = [];
		if (!firstName) errors.push('First name is required.');
		if (!lastName) errors.push('Last name is required.');
		if (!email) errors.push('E-mail is required.');
		return errors;
	};

	onPassChangeClick = () => this.setState({ activeModal: 'change-pass' });

	onModalClose = () => this.setState({ activeModal: null });

	render() {
		const { validationErrors, updateStatus, updateError, activeModal, fetchStatus, fetchError, firstName, lastName, email } = this.state;

		const amountOfErrors = validationErrors.length;

		if (fetchStatus === 'pending') return <Spinner height="273px" text={`Loading user info`} />;
		if (fetchStatus === 'failure') return <p>Error: {fetchError}</p>;

		return (
			<div className="user-info animated fadeIn">
				<h2>User information</h2>
				<form onSubmit={this.handleSubmit}>
					<div className="hbox">
						<InputField
							label="First name"
							handleChange={this.handleFormChange}
							value={firstName}
							name={'firstName'}
							type="text"
							required={true}
							className="grow-1 firstName-field"
						/>
						<InputField
							label="Last name"
							handleChange={this.handleFormChange}
							value={lastName}
							name={'lastName'}
							type="text"
							required={true}
							className="grow-1 lastName-field"
						/>
					</div>
					<div className="hbox">
						<InputField
							label="E-Mail"
							handleChange={this.handleFormChange}
							value={email}
							type="text"
							name={'email'}
							readOnly={true}
							required={true}
							className="grow-1 email-field"
						/>
						<div className="grow-1 changepass-field">
							<button className="changepass-btn" type="button" onClick={this.onPassChangeClick}>
								Change password
							</button>
						</div>
					</div>
					{amountOfErrors > 0 && (
						<ul className="validation-errors">
							{validationErrors.map((txt, i) => (
								<li key={i}>
									<i className="mdi mdi-alert-octagon" /> {txt}
								</li>
							))}
						</ul>
					)}

					{updateStatus === 'failure' && <p className="error-msg">Error: {updateError}</p>}

					<div className="btn-ctn">
						<button className="btn primary" disabled={updateStatus === 'pending'} onClick={this.onProfileSubmit} type="submit">
							{updateStatus === 'pending' ? 'Saving...' : 'Save'}
						</button>
					</div>
				</form>
				<ChangePassModal isOpen={activeModal === 'change-pass'} onRequestClose={this.onModalClose} />
			</div>
		);
	}
}

export default UserInfo;



// WEBPACK FOOTER //
// ./src/views/user-profile/user-info/UserInfo.js